import React from 'react';
import * as R from 'ramda';
import { withProps } from 'react-recompose';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HistoryList from '../main/HistoryList';
import { format } from 'date-fns-tz';
import { css, Typography } from '@mui/material';

function formatDate(d) {
	return format(new Date(d), 'MM/dd/yyyy');
}
const baseStyle = {
	display: 'flex',
	gap: '16px',
	alignItems: 'center'
};
const actionStyle = css(baseStyle);

const billingStyle = css({
	...baseStyle,
	gap: '8px',
	'&>div': {
		color: 'orange'
	}
});

const secondRowWrapStyle = css({
	display: 'flex',
	flexDirection: 'column'
});

const enhance = R.compose(
	withProps(() => ({
		onPrimaryText: ({ long_name }) => `${long_name}`,
		onSecondaryText: ({ active_date, end_date, type_code, isRepeating }) => {
			return (
				<div css={secondRowWrapStyle}>
					{isRepeating && (
						<span
							css={css({
								display: 'flex',
								alignItems: 'center',
								gap: '16px',
								marginTop: '16px'
							})}>
							<span>
								Start Date:{' '}
								<Typography color="primary">{formatDate(active_date)}</Typography>
							</span>
							<span>&#x2192;</span>
							<span>
								End Date:{' '}
								<Typography color="primary">{formatDate(end_date)}</Typography>
							</span>
						</span>
					)}
					<div css={billingStyle}>
						{isRepeating
							? <>
									<span>Billing Cycle:</span>
									<div>Monthly</div>
								</>
							: <div>Charge</div>}
					</div>
				</div>
			);
		},
		onActionCmp: ({ amount }) => (
			<div css={actionStyle}>
				<span>{amount}</span>
			</div>
		),
		onIcon: ({ signed }) => (
			<HandshakeIcon color={signed ? 'primary' : 'primary'} />
		)

		//url: `/training/class/details/list/${classID}`
	})),
	/* loadDataHOC('GET', '/get/legal/list', {
		reactQuery: { queryName: 'legalList' }
	}), */
	withProps(({ data, ...rest }) => {
		const total = R.reduce(
			(acc, { amount }) => acc + +R.replace(/\$/gi, '', amount),
			0,
			data
		);

		return {
			data: R.map(
				({ type_code, ...rest }) => ({
					total: total.toFixed(2),
					isRepeating: [501, 503].includes(type_code),
					...rest
				}),
				data
			),
			...rest
		};
	})
);

const LegalList = enhance(HistoryList);
export default LegalList;
